import { Navigate } from "react-router-dom";
// project imports

import MainLayout from "../layout/MainLayout";
import DeviceForm from "../views/forms/DeviceForm";
import DeviceModelForm from "../views/forms/DeviceModelForm";
import ModelExtension from "../views/forms/ModelExtension";
import DeviceModelList from "../views/reports/DeviceModelList";
import StateAdminDeviceModelView from "../views/detailsview/StateAdminDeviceModelView";
import { useSelector } from "react-redux";
import UnapproveCopList from "../views/reports/UnapproveCopList";
import StateAdminCOPModelView from "../views/detailsview/StateAdminCOPModelView";
import BulkUpload from "../views/forms/BulkUpload";
import AssignDevice from "../views/forms/AssignDevice";
import BulkDeviceAssign from "../views/forms/BulkDeviceAssign";
import ShowDevice from "../views/showDevice/ShowDevice";
import AvailableForSale from "../views/showDevice/AvailableForSale";
import ConfigureDevice from "../views/tagging/ConfigureDevice";
import { decipherEncryption } from "../helper";
import NotAuthorized from "../views/pages/NotAuthorized";
import TaggedList from "../views/reports/TaggedList";
import SimActivation from "../views/pages/device/SimActivation";
import ListSimActivation from "../views/pages/device/ListSimActivation";
import CombinedStockReport from "../views/showDevice/CombinedStockReport";
import AllTaggedDevice from "../views/showDevice/AllTaggedDevice";
import ApprovedModelsList from "../views/reports/ApprovedModelsList";
import ApprovedCOPsList from "../views/reports/ApprovedCOPsList";
import EsimStatusReport from "../views/reports/EsimStatusReport";
import DealerActivationCommercial from "../views/forms/DealerActivationCommand";
import ManufacturerOnboarding from "../views/pages/ManufacturerOnboarding";
import DeviceModelTechnicalOnboardingCreate from "../views/pages/DeviceModelTechnicalOnboardingCreate";
import DeviceModelTechnicalOnboardingList from "../views/pages/DeviceModelTechnicalOnboardingList";
import SalesInvoiceReport from "views/reports/SalesInvoicereport";
import DispatchInbound from "../esimInventory/FactoryManagement/DispatchInbound";
import DispatchOutbound from "../esimInventory/FactoryManagement/DispatchOutbound";

const PrivateRoute = ({ element, roles }) => {
  const myDecipher = decipherEncryption("skytrack");
  const userData = sessionStorage.getItem("cookiesData") || localStorage.getItem("cookiesData");
  const data = userData && userData.split("-").map((item) => myDecipher(item));
  const isAuthenticated =
    useSelector((state) => state.login.user.isAuthenticated) ||
    sessionStorage.getItem("isAuthenticated") ||
    localStorage.getItem("isAuthenticated");
  const userRoles = userData && data.length > 2 && data[1]; // Get the user role after login from redux store
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  if (
    roles &&
    roles.length > 0 &&
    !roles.some((role) => userRoles.includes(role))
  ) {
    // User does not have any of the required roles
    return <NotAuthorized />;
  }
  return element;
};

const applyPrivateRoute = (route) => ({
  ...route,
  element: <PrivateRoute element={route.element} roles={route.roles} />,
});

const DeviceRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/manufacturer/onboarding",
      element: <ManufacturerOnboarding />,
      roles: ["devicemanufacture"],
    },
    // {
    //   path: "/manufacturer/technical-onboarding/create",
    //   element: <DeviceModelTechnicalOnboardingCreate />,
    //   roles: ["devicemanufacture"],
    // },
    // {
    //   path: "/manufacturer/technical-onboarding/list",
    //   element: <DeviceModelTechnicalOnboardingList />,
    //   roles: ["devicemanufacture"],
    // },
    // {
    //   path: "/device/bulk-assign",
    //   element: <BulkDeviceAssign />,
    //   roles: ["devicemanufacture"],
    // },
    {
      path: "/device/new",
      element: <DeviceForm formTitle="New Device Form" />,
      roles: ["devicemanufacture"],
    },
    // {
    //   path: "/device/eSimActivation",
    //   element: <SimActivation />,
    //   roles: ["dealer"],
    // },
    {
      path: "/deviceModel/new",
      element: <DeviceModelForm />,
      roles: ["devicemanufacture"],
    },
    {
      path: "/deviceModel/extension",
      element: <ModelExtension formTitle="Model Extension" />,
      roles: ["devicemanufacture"],
    },
    // {
    //   path: "/device/list",
    //   element: <DeviceModelList />,
    //   roles: ["superadmin", "stateadmin"],
    // },
    // {
    //   path: "/deviceCOP/list",
    //   element: <UnapproveCopList />,
    //   roles: ["superadmin", "stateadmin"],
    // },
    {
      path: "/deviceModel/view/:deviceId",
      element: <StateAdminDeviceModelView />,
      roles: ["superadmin", "devicemanufacture", "stateadmin", "dealer"],
    },
    {
      path: "/deviceCOPModel/view/:deviceId",
      element: <StateAdminCOPModelView />,
      roles: ["superadmin", "devicemanufacture", "stateadmin", "dealer"],
    },
    {
      path: "/device/bulkupload",
      element: <BulkUpload />,
      roles: ["devicemanufacture"],
    },
    {
      path: "/device/show-device",
      element: <ShowDevice />,
      roles: ["superadmin", "devicemanufacture", "stateadmin", "dtorto"],
    },
    {
      path: "/device/assign-device",
      element: <AssignDevice />,
      roles: ["devicemanufacture"],
    },
    {
      path: "/device/dispatch-inbound",
      element: <DispatchInbound />,
      roles: ["devicemanufacture","dealer","factorymanager"],
    },
    {
      path: "/device/dispatch-outbound",
      element: <DispatchOutbound />,
      roles: ["devicemanufacture","dealer","factorymanager"],
    },
    {
      path: "/device/activation-request/:deviceStatus",
      element: <ListSimActivation />,
      roles: ["esimprovider"],
    },
    {
      path: "/device/show-available-device",
      element: <AvailableForSale />,
      roles: ["superadmin", "dtorto"],
    },
    {
      path: "/device/show-tagged-device",
      element: <TaggedList />,
      roles: ["superadmin", "devicemanufacture", "dealer"],
    },
    {
      path: "/device/combined-stock-report",
      element: <CombinedStockReport />,
      roles: ["superadmin", "devicemanufacture"],
    },
    {
      path: "/device/fit-device",
      element: <ConfigureDevice status="Available_for_fitting" />,
      roles: ["dealer"],
    },
    {
      path: '/device/all-tagged-devices',
      element: <AllTaggedDevice />,
      roles: ['superadmin', 'devicemanufacture', 'stateadmin'],
    },
    // {
    //   path: "/device/approved-models",
    //   element: <ApprovedModelsList />,
    //   roles: ["superadmin", "stateadmin"],
    // },
    // {
    //   path: "/device/approved-cops",
    //   element: <ApprovedCOPsList />,
    //   roles: ["superadmin", "stateadmin"],
    // },
    // {
    //   path: "/device/esim-status",
    //   element: <EsimStatusReport />,
    //   roles: ["dealer"],
    // },
    {
      path: "/device/commercial-activation",
      element: <DealerActivationCommercial />,
      roles: ["dealer"],
    },
    {
      path: "/device/salesInvoiceReport",
      element: <SalesInvoiceReport />,
      roles: ["dealer","superadmin","devicemanufacture"],
    },
  ].map((route) => applyPrivateRoute(route)),
};

export default DeviceRoutes;
